import { render, staticRenderFns } from "./reg-nav.vue?vue&type=template&id=dcf55002"
import script from "./reg-nav.vue?vue&type=script&lang=js"
export * from "./reg-nav.vue?vue&type=script&lang=js"
import style0 from "./reg-nav.vue?vue&type=style&index=0&id=dcf55002&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcf55002')) {
      api.createRecord('dcf55002', component.options)
    } else {
      api.reload('dcf55002', component.options)
    }
    module.hot.accept("./reg-nav.vue?vue&type=template&id=dcf55002", function () {
      api.rerender('dcf55002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/reg-nav.vue"
export default component.exports